<div class="bannerimage" *ngFor="let bannerimage of bannerimages; let i=index;">
    <img src="{{imagepath}}deckimages/{{bannerimage.dplImage}}" class="img-fluid" alt="...">
</div>